// TODO: Нужен ли Paycore Client SDK?
/* eslint-disable */

import HttpRequest from '../http_request';
import axios from 'axios';

const publicInstance = axios.create({
  withCredentials: false,
  baseURL:
    process.env.VUE_APP_PUBLIC_API_URL ||
    `${window.location.protocol}//${window.location.hostname
      .split('.')
      .map((c, i) => (i === 0 && c === 'hpp' ? 'api' : c))
      .join('.')}/public-api`,
});

class PublicAPIProvider extends HttpRequest {
  constructor() {
    super(publicInstance);
  }
  async createPaymentInvoice(data) {
    /* eslint-disable */
    return await this.post('/payment-invoices', { ...data });
  }

  async createTestInvoice(data) {
    return await this.post('/payment-invoices', { ...data });
  }

  /**
   * @param {id}  id payment Invoice ID
   */
  async getPaymentInvoiceById(id) {
    // return await new Promise(r => setTimeout(r, 1000));
    return await this.fetch(`/payment-invoices/${id}`);
  }

  async confirmPaymentInvoice({ id, data = {} }) {
    return await this.post(`/payment-invoices/${id}/confirm`, { ...data });
  }

  async getCheckoutOptions(params = {}) {
    return await this.fetch(`/account/checkout-options`, params);
  }
}

export default new PublicAPIProvider();
